import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from '@lichtblick/photon/atoms/text/text';
import { SolarS } from '@lichtblick/photon/icons/technology/solar-s';
import styles from './funnel-embed.module.scss';
const ProgressBar = ({ progress })=>/*#__PURE__*/ _jsx("div", {
        className: styles['progress-container'],
        children: /*#__PURE__*/ _jsx("div", {
            className: styles.progress,
            style: {
                width: `${progress}%`
            },
            children: /*#__PURE__*/ _jsxs(Text, {
                className: styles['progress-number'],
                size: "xs",
                children: [
                    progress,
                    "%"
                ]
            })
        })
    });
export const FunnelEmbedHeader = ({ progressInPercent, title })=>{
    return /*#__PURE__*/ _jsxs("section", {
        className: styles['funnel-embed-header'],
        children: [
            /*#__PURE__*/ _jsxs("header", {
                className: styles['headline-and-icon'],
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        className: styles['sub-headline'],
                        size: "xs",
                        children: title ?? 'Jetzt kostenlos SolarAnlage berechnen'
                    }),
                    /*#__PURE__*/ _jsx(SolarS, {
                        className: styles.icon
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(ProgressBar, {
                progress: progressInPercent
            })
        ]
    });
};

//# sourceMappingURL=b2b-funnel-embed-header.js.map